import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import EventListingFilters from './event-listing-filters';
import useFetch from '../../react-hooks/use-fetch';
import EventListingItem from './event-listing-item';
import Pagination from '../../react-components/pagination';

const Index = props => {
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(props.defaultItemsPerPage);
  const { response, isLoading, fetch } = useFetch({ url: props.api });
  const filters = response?.data?.body?.filters;
  const list = response?.data?.body?.list;
  const pages = response?.data?.body?.pages;
  const $eloquaModal = useMemo(
    () => document.getElementById(props.gatedModalId),
    [props.gatedModalId]
  );
  const elem = useRef({});

  const getSelectedFiltersParams = newFilter => {
    const params = {};

    filters.forEach(filter => {
      params[filter.value] = filter.selected.value;
    });
    if (newFilter) {
      params[newFilter.filter] = newFilter.value;
    }
    return params;
  };

  const onFilterChange = filter => {
    const params = getSelectedFiltersParams(filter);
    params.page = 1;
    setPage(1);
    fetch({ url: props.api, params });
  };

  const onPageChange = newPage => {
    const params = getSelectedFiltersParams();
    params.page = newPage;
    params.itemsPerPage = itemsPerPage;
    setPage(newPage);
    fetch({ url: props.api, params });
    scrollToTop();
  };

  const onItemsPerPageChange = newItemsPerPage => {
    const params = getSelectedFiltersParams();
    params.page = 1;
    params.itemsPerPage = newItemsPerPage;
    setPage(1);
    setItemsPerPage(newItemsPerPage);
    fetch({ url: props.api, params });
    scrollToTop();
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: elem.current.offsetTop - 50,
      behavior: 'smooth'
    });
  };

  return (
    <div ref={elem}>
      <EventListingFilters
        labelItemsPerPage={props.labelItemsPerPage}
        total={pages}
        onChange={onFilterChange}
        onItemsPerPageChange={onItemsPerPageChange}
        itemsPerPage={itemsPerPage}
        loading={isLoading}
        filters={filters}
        itemsPerPageOptions={props.itemsPerPageOptions}
      />
      {!isLoading && !list?.length && (
        <div
          className="rte_wrapper basic-rte event-listing__items"
          dangerouslySetInnerHTML={{ __html: props.noResultsHtml }}
        />
      )}
      {list && list?.length ? (
        <ul className="event-listing__items">
          {list.map(item => (
            <EventListingItem
              key={item.id}
              labelRegister={props.labelRegister}
              labelPersons={props.labelPersons}
              modal={$eloquaModal}
              {...item}
            />
          ))}
        </ul>
      ) : null}
      {!!pages && (
        <Pagination
          labelItemsPerPage={props.labelItemsPerPage}
          labelPrev={props.labelPrev}
          labelNext={props.labelNext}
          onPageChange={onPageChange}
          onItemsPerPageChange={onItemsPerPageChange}
          current={page}
          total={pages}
          itemsPerPage={itemsPerPage}
          itemsPerPageOptions={props.itemsPerPageOptions}
        />
      )}
    </div>
  );
};

Index.propTypes = {
  labelItemsPerPage: PropTypes.string,
  labelPrev: PropTypes.string,
  labelNext: PropTypes.string,
  labelRegister: PropTypes.string,
  labelPersons: PropTypes.string,
  itemsPerPageOptions: PropTypes.string.isRequired,
  defaultItemsPerPage: PropTypes.string.isRequired
};

Index.defaultProps = {
  labelItemsPerPage: 'Show per page',
  labelPrev: 'Prev',
  labelNext: 'Next',
  labelRegister: 'Register',
  labelPersons: 'Speakers'
};

export default Index;
